import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import QRCode from '../QRCode'
import { ReactComponent as CheckMark } from '../../assets/icons/synced-icon.svg'

import { RICH_CHECKOUT_TEXT_PROMPT, TEAM_LOGO_EXISTS } from '../../constants'

import { generateURL } from '../../utils/richCheckout'

import styles from './PayWithApp.module.scss'

const PayWithApp = ({ cartItems, deviceId, isScanned, orderNumber, orderUuid, total, className }) => {
  const classNames = cn(styles.payWithApp, className)

  const qrCodeData = generateURL(orderUuid, orderNumber, deviceId, total, cartItems)

  return (
    <div className={classNames}>

      <div className={styles.qrCode}>
        {!isScanned && ( <QRCode data={qrCodeData} className={styles.qrCode} /> )}

        {isScanned && ( <img src='/teamLogo.png' alt='Customer Logo' /> )}
      </div>

      <div className={styles.headerText}>
        {!isScanned && (
          <>
            {TEAM_LOGO_EXISTS && (
              <span className={styles.teamLogoInline}>
                <img src='/teamLogo.png' alt='Customer Logo' />
              </span>
            )}
            <span>Pay with App</span>
          </>
        )}

        {isScanned && (
          <>
            <span className={styles.scannedCheck}>
              <CheckMark/>
            </span>
            <span>Scanned!</span>
          </>
        )}
      </div>

      <div className={styles.instructionsText}>
        {isScanned ? "Complete this order on your phone." : RICH_CHECKOUT_TEXT_PROMPT}
      </div>
    </div>
  )
}

PayWithApp.defaultProps = {
  cartItems: [],
  deviceId: '',
  isScanned: false,
  orderNumber: 0,
  orderUuid: '',
  total: 0,
}

PayWithApp.propTypes = {
  cartItems: PropTypes.array,
  deviceId: PropTypes.string,
  isScanned: PropTypes.bool,
  orderNumber: PropTypes.number,
  orderUuid: PropTypes.string,
  total: PropTypes.number,
}

export default PayWithApp
